import React from "react";
import { useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../HomeDashboardLayout";

import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "../questionBank/QuestionBankList.css";
import HeaderProfileSection from "../HeaderProfileSection";
import MyWalletSidebar from "../MyWalletSidebar";
import SubscriptionCard from "./SubscriptionCard";

const Subscription = () => {
  const navigate = useNavigate();
  return (
    <>
      <style>{`
          .homeDashboard-wrapper .page-content {
            padding-right: 0;
          }
        .homeDashboard-wrapper .main-content {
          height: 100vh;
          overflow: hidden;
          box-sizing: border-box;
          padding-bottom: 35px;
          min-height:0;
          
        }
      `}</style>
      <HomeDashboardLayout showHeader={false}>
        <div className="qbl-page qbankList-page page-padding fixed-page-btn">
          <div className="start-quiz qbl-main instruction-main">
            <div className="hideProfile-page ">
              {/* Page header */}
              <div className="categories-page-header mb-0">
                <div>
                  <button type="button" className="categories-back-button" onClick={() => navigate(-1)}>
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </div>
                <div>
                  <h4 className="d-flex categories-page-title">
                    {" "}
                    Subscription{" "}
                  </h4>
                </div>
                <div>
                  <HeaderProfileSection />
                </div>
              </div>
            </div>

            {/* =====================================
            MAIN CONTENT
        ====================================== */}
            <SubscriptionCard />
          </div>
          <MyWalletSidebar withTopOffset={false} />
        </div>
      </HomeDashboardLayout>
    </>
  );
};

export default Subscription;
